import { useState } from 'react';
import {
  DataTableHeader,
  DataTablePagination,
  DataTableTable,
  Panel,
  PanelInset,
} from '@customerio/pluma-components/react';

/**
 * What every list in the data index shares: the box someone types a search
 * into, and the frame the rows are drawn in.
 *
 * The lists themselves have little else in common — one is editable and
 * selectable and filtered, another is read-only — so what is shared here is
 * the chrome around them rather than a table component they both configure.
 */

/**
 * The text in the search box, which is not yet the search.
 *
 * Searching costs a request, so it happens on Enter or on clearing the box
 * rather than on every keystroke. The box therefore holds text the URL does
 * not, and forgets it whenever the URL's own search changes underneath it —
 * on Back, or when a new search is committed.
 */
export function useSearchDraft(committed: string) {
  const [draft, setDraft] = useState({ committed, text: committed });

  return {
    text: draft.committed === committed ? draft.text : committed,
    setText: (text: string) => setDraft({ committed, text }),
  };
}

/**
 * The rows and the pager, inside the panel the data index draws them in.
 *
 * Rendered as a `DataTable` child, so it reads the table from context rather
 * than taking it as a prop.
 */
export function DataIndexTableFrame() {
  return (
    <>
      <Panel>
        <DataTableHeader />
        <PanelInset>
          <DataTableTable />
        </PanelInset>
      </Panel>
      <DataTablePagination mt="200" />
    </>
  );
}
